import { render, staticRenderFns } from "./ExpandableRowColumn.vue?vue&type=template&id=a5afef9c&scoped=true&"
import script from "./ExpandableRowColumn.vue?vue&type=script&setup=true&lang=js&"
export * from "./ExpandableRowColumn.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./ExpandableRowColumn.vue?vue&type=style&index=0&id=a5afef9c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5afef9c",
  null
  
)

export default component.exports